var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"menu nav-submenu submenu is-dropdown-submenu first-sub vertical",attrs:{"data-submenu":"","role":"menubar"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }